import React, { useContext } from 'react';
import { AccordionContext } from '~/context/accordionContext';

const Accordion = ({ children, className }) => (
  <div className={`accordion ${className}`}>
    {children}
  </div>
);

const AccordionToggle = ({ children, className }) => {
  const { accordionOpened, toggleAccordion } = useContext(AccordionContext);

  return (
    <button
      type="button"
      className={`${className || ''} ${accordionOpened ? 'open' : ''}`}
      onClick={toggleAccordion}
    >
      {children}
    </button>
  );
};

const AccordionCollapse = ({ children }) => {
  const { accordionOpened } = useContext(AccordionContext);

  return (
    <div className={`collapse ${accordionOpened ? 'show' : ''}`}>
      {children}
    </div>
  );
};

Accordion.Toggle = AccordionToggle;
Accordion.Collapse = AccordionCollapse;

export default Accordion;
